import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { useFileUpload } from '../UploadContext';

export default function UploadTrigger({
  className = '',
  children = 'Upload new image'
}) {
  const { isDisabled, onTriggerUpload } = useFileUpload();

  return (
    <UiKit.Button
      size="sm"
      variant="outline"
      onClick={onTriggerUpload}
      disabled={isDisabled}
      className={cn(styles.button, className)}
    >
      {children}
    </UiKit.Button>
  );
}
